export default {
  signin: {
    title: 'تسجيل الدخول',
    subtitle: 'أدخل بريدك الإلكتروني وكلمة المرور لتسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    signInButton: 'تسجيل الدخول',
    noAccount: 'ليس لديك حساب؟',
    signUpLink: 'إنشاء حساب',
    or: 'أو',
    signInWith: 'تسجيل الدخول باستخدام',
    error: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    success: 'تم تسجيل الدخول بنجاح'
  },
  signup: {
    title: 'إنشاء حساب',
    subtitle: 'أنشئ حسابك للبدء',
    name: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    agreeTerms: 'أوافق على الشروط والأحكام',
    signUpButton: 'إنشاء حساب',
    haveAccount: 'لديك حساب بالفعل؟',
    signInLink: 'تسجيل الدخول',
    or: 'أو',
    signUpWith: 'إنشاء حساب باستخدام',
    success: 'تم إنشاء الحساب بنجاح',
    error: 'فشل إنشاء الحساب'
  },
  forgotPassword: {
    title: 'نسيت كلمة المرور',
    subtitle: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور',
    email: 'البريد الإلكتروني',
    resetButton: 'إعادة تعيين كلمة المرور',
    backToSignIn: 'العودة إلى تسجيل الدخول',
    success: 'تم إرسال بريد إعادة تعيين كلمة المرور',
    error: 'فشل إرسال بريد إعادة التعيين'
  },
  resetPassword: {
    title: 'إعادة تعيين كلمة المرور',
    subtitle: 'أدخل كلمة المرور الجديدة',
    password: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    resetButton: 'إعادة تعيين كلمة المرور',
    success: 'تم إعادة تعيين كلمة المرور بنجاح',
    error: 'فشل إعادة تعيين كلمة المرور'
  },
  start: {
    title: 'البدء',
    subtitle: 'أدخل بريدك الإلكتروني للبدء مع 1Task',
    email: 'ادخل بريدك الإلكتروني لبدء مع 1Task',
    newOrganization: 'منظمة جديدة',
    enterDetails: 'أدخل تفاصيل مساحة عمل شركتك الجديدة',
    agreeTerms: 'أوافق على الشروط والأحكام',
    getStarted: 'البدء',
    alreadyHaveAccount: 'هل لديك حساب بالفعل؟',
    signIn: 'تسجيل الدخول',
    attentionIsNewCurrency: '"الانتباه هو العملة الجديدة"',
    effortlessWriting: 'كلما بدت الكتابة أكثر سهولة، كلما بذل الكاتب مجهودًا أكبر في العملية.',
    manageYourTasks: 'أدر',
    fastAndEasyAndSmart: 'بسرعة وسهولة وذكاء',
    pricing: 'الأسعار'
  }
}

